import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'
import CustomSelect from'../../GlobalComponents/CustomSelect'

var reformatOptions = function(raw, label, value) {
    return raw.map(function(data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];
  
      return newObj;
    });
};

class IndexView extends Component {

    updateBloc = new UpdateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            dataFormLevel: [{}],
            optionTipe : [
                { label: "Manajerial", value: "1" },
                { label: "Teknis", value: "2" },
                { label: "Sosio Kultural", value: "3" }
            ],
            optionCategories: [],
            optionCategoriesSelected:[],
            dataForm: {},
            levelComps: [
                {
                    name: "",
                    level : 1
                },
            ]
        }
    }

    addLevel = () => {
        let count = this.state.levelComps.length;
        this.setState({
            levelComps: [
                ...this.state.levelComps,
                {
                    name : "",
                    level : count == 0 ? (count+1) : this.state.levelComps.slice(-1)[0].level
                }
            ]
        })

        console.log(this.state.levelComps)
    }

    delLevel = (data) => {
        let count = this.state.levelComps.length-1;
        this.setState({
            levelComps: [
                ...this.state.levelComps.filter((val) => val!=data)
                
                // (count-1)
            ]
        })
    }

    reformatLevel = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["name"] = data.level_name;
          newObj["level"] = data.level_no;
      
          return newObj;
        });
    }

    submitData = async () => {
        await this.updateBloc.fetchUpdate(this.state.dataForm)
    }

    handleChangeInputLevel = (e, index) => {
        // 1. Make a shallow copy of the items
        let items = [...this.state.levelComps];
        // 2. Make a shallow copy of the item you want to mutate
        let item = {...items[index]};
        // 3. Replace the property you're intested in
        item.name = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({levelComps : items});
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        // console.log(values)
        // return
        this.setState({
            dataForm: {
                uuid: this.state.dataForm.uuid,
                ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {

        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            dataForm: {
                                uuid: response.competence_uuid,
                                code: response.competence_code,
                                name: response.competence_name,
                                name_eng: response.comptenece_eng_name,
                                type:response.competence_type,
                                description: response.comptenece_description,
                                category_id:response.competence_category_id,
                                category_name:response.category_name,
                            },
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.detailLevel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response)
                        if (response.length > 0) {
                            this.setState({
                                levelComps: this.reformatLevel(response),
                            })
                        }
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.updateBloc.fetchDetail({uuid: queryParams.get('uuid') })
        this.updateBloc.fetchLevel({uuid: queryParams.get('uuid') })

        // get data type
        this.updateBloc.accategoriesChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response)
                        
                        this.setState({
                            optionCategories: reformatOptions(
                                response.result, 
                                'category_name',
                                'category_id'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.fetchCategories({})
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle>Form Update Kamus Kompetensi</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Ubah Kamus Kompetensi
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fielCode"
                                                className="col-md-3 col-form-label"
                                            >
                                            Kode <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="code"
                                                    placeholder="Kode..."
                                                    type="text"
                                                    errorMessage="Masukkan kode"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="fielCode"
                                                    value={this.state.dataForm.code}
                                                />
                                            </Col>
                                        </Row>
                                        {/* <Row className="mb-3">
                                            <Label htmlFor="fieldGender" className="col-md-3 col-form-label">Tipe </Label>
                                            <Col md="6">
                                            <CustomSelect 
                                                    name="tipe"
                                                    errorMessage="Pilih Tipe"
                                                    options={this.state.optionTipe} 
                                                    placeholder="Pilih Tipe"
                                                    defaultValue={this.state.dataForm.optionTipe}
                                                />
                                            </Col>
                                        </Row> */}
                                        <AvField
                                            name="tipe"
                                            type="hidden"
                                            id="tipe"
                                            value="1"
                                        />
                                        <Row className="mb-3">
                                            <Label htmlFor="fieldGender" className="col-md-3 col-form-label">Kategori </Label>
                                            <Col md="6">
                                            <CustomSelect 
                                                    name="kategori"
                                                    errorMessage="Pilih Kategori"
                                                    options={this.state.optionCategories} 
                                                    placeholder="Pilih Kategori"
                                                    defaultValue={this.state.dataForm.category_id}
                                                />
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fieldTitle"
                                                className="col-md-3 col-form-label"
                                            >
                                            Kompetensi <span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="name"
                                                    placeholder="Nama Kamus Kompetensi..."
                                                    type="text"
                                                    errorMessage="Masukkan Nama Kamus Kompetensi"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="fieldTitle"
                                                    value={this.state.dataForm.name}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fieldTitle"
                                                className="col-md-3 col-form-label"
                                            >
                                            <i>English Name</i><span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="name_en"
                                                    placeholder="Nama Kamus Kompetensi dalam bahasa inggris..."
                                                    type="text"
                                                    errorMessage="Masukkan Nama Kamus Kompetensi Dalam Bahasa Inggris"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="fieldTitle"
                                                    value={this.state.dataForm.name_eng}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fielDescription"
                                                className="col-md-3 col-form-label"
                                            >
                                            Deskripsi 
                                            </label>
                                            <Col md="6">
                                                <AvField
                                                    name="description"
                                                    placeholder="Keterangan..."
                                                    type="textarea"
                                                    errorMessage="Masukkan Keterangan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="fielDescription"
                                                    value={this.state.dataForm.description}
                                                />
                                            </Col>
                                        </Row>
                                        {/* <Row className="mb-3">
                                            <Label htmlFor="fieldGender" className="col-md-3 col-form-label">Level Kompetensi<span className="text-danger">*</span></Label>
                                            <Col md="6">
                                                <CustomSelect 
                                                    name="level[]"
                                                    errorMessage="Pilih Level"
                                                    options={this.state.optionLevel} 
                                                    placeholder="Pilih Level"
                                                    // validate={{ required: { value: true } }}
                                                    defaultValue={this.state.dataForm.optionLevel}
                                                    isMulti="true"
                                                />
                                            </Col>
                                        </Row> */}


                                        <Row className="mb-3">
                                            <Label htmlFor="fieldGender" className="col-md-3 col-form-label">Level Kompetensi<span className="text-danger">*</span></Label>
                                            <Col md="6">
                                            {/* <div className="row">
                                                <div className="col-md-10">
                                                    <AvField
                                                        name="level[]"
                                                        placeholder="Level-1"
                                                        type="text"
                                                        errorMessage="Masukkan Level"
                                                        className="form-control mb-2"
                                                        validate={{ required: { value: true } }}
                                                        id="fielDescription"
                                                    />
                                                </div>
                                                <div className="col-md-2 text-right">
                                                    <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                                        color="success" 
                                                        type="button"
                                                        onClick={this.addLevel}
                                                        ><i className="uil-plus-circle"></i>
                                                    </Button>
                                                </div>
                                            </div> */}

                                                {
                                                    this.state.levelComps.map((data, index) => {
                                                        return (
                                                            <div className="row">
                                                                <div className="col-md-10">
                                                                <AvField
                                                                    name={`level[${index}]`}
                                                                    placeholder={`Level-${(index+1)}`}
                                                                    type="text"
                                                                    errorMessage="Masukkan Level"
                                                                    className="form-control mb-2"
                                                                    onChange={(e) => {
                                                                        this.handleChangeInputLevel(e, index)
                                                                    }}
                                                                    value={data.name}
                                                                    validate={{ required: { value: true } }}
                                                                />
                                                                </div>
                                                                <div className="col-md-2 text-right">
                                                                    {
                                                                        index == 0 ? 
                                                                        <div className="col-md-2 text-right">
                                                                            <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                                                                color="success" 
                                                                                type="button"
                                                                                onClick={this.addLevel}
                                                                                ><i className="uil-plus-circle"></i>
                                                                            </Button>
                                                                        </div> :
                                                                            <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                                                                color="danger" 
                                                                                type="button"
                                                                                onClick={() => {
                                                                                    this.delLevel(data)
                                                                                }}
                                                                                ><i className="uil-trash-alt"></i>
                                                                            </Button>
                                                                    }
                                                                    
                                                                </div>
                                                            </div>
                                                        )    
                                                    })
                                                }

                                                
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kamuskompetensi/teknis.html">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kamuskompetensi/teknis.html'/>
                : null }
            </Fragment>
        )
    }

}

//export default IndexView
export default withRouter(IndexView);